import { useTranslation } from "react-i18next";
import TutorialsList from "../../components/tutorials/tutorials-list";

export default function VideoDemo({ infoUser }) {
  const [t] = useTranslation("global");

  return (
    <div style={{ maxWidth: 900, margin: "0 auto", padding: "16px" }}>
      <h2 style={{ fontSize: "2rem", textAlign: "left", marginBottom: "24px" }}>
        {t(`tutorials.title`)}
      </h2>
      <div style={{ width: "100%" }}>
        <div style={{ paddingRight: "24px" }}>
          <TutorialsList />
        </div>
      </div>
    </div>
  )
}
